import logo2 from "../../assets/7white.png";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../assets/coldCoffee.png";
import cube from "../../assets/2cubes.png"
import walletG from "../../assets/walletIcon.png"
import WalletA from "../../assets/walletA.png"
import Confetti from "react-confetti";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QrCodeIcon } from "lucide-react";

export default function ModalPago({ pagarModal, isSetPagar, clickPagar }) {
  const { event } = useSelector((state) => state.coffee);
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsConfettiActive(true);
  }, []);

  return (
    <AnimatePresence>
      {pagarModal && (
        <motion.div
          key="modal-background"
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm "
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          {isConfettiActive && <Confetti recycle={false} />}
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-cream sm:flex justify-between pr-44 rounded-lg p-6  sm:h-64 h-[700px] font-poppina sm:w-[700px] w-[300px] relative mx-4 border border-gray-100"
          >
            <div className="sm:border-r-2 pr-5 sm:border-r-mandarin ">
              <img
                className="sm:w-[258px] sm:block hidden w-[300px] max-xl:-left-0  sm:rotate-90 absolute sm:right-[-60px] rounded-t-lg sm:top-[57px] top-0 "
                src={logo}
                alt=""
              />
              <img
                className="sm:w-[258px] absolute h-[120px] rounded-t-lg -left-0 top-0 w-[350px] sm:hidden block "
                src={logo}
                alt=""
              />
              <div className="w-full flex justify-between h-auto dark:bg-gray-800 rounded-lg items-center">
                <motion.div
                  className=" mt-8"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  
                  <QrCodeIcon className="text-mandarin w-32 h-32 sm:mt-0 mt-20 sm:ml-0 ml-14 " />
                </motion.div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center">
            <h1 className="sm:text-4xl text-3xl text-mandarin font-bold text-center mb-5 sm:ml-0 ml-32 sm:block hidden  ">Compra exitosa!</h1>
            <h1 className="sm:text-4xl text-3xl text-mandarin font-bold text-center mb-5 sm:ml-0 ml-36  sm:hidden block w-96  ">Compra exitosa!</h1>
                <div className="sm:ml-0 ml-36 sm:border-t-0 border-t-2 border-t-mandarin ">
                    
                    <p className="text-center font-semibold text-2xl sm:block hidden " >Rodrigo Silva Bilbao</p>
                    <p className="text-center font-semibold text-2xl sm:hidden block w-52 mt-5 " >Rodrigo Silva Bilbao</p>
                    <p className="text-center text-lg ">Evento: <span className="font-bold" >{event.tipo}</span> </p>
                    <p className="text-center">No. de Compra <span className="font-semibold text-lg text-center " >1045AF</span></p>
                    
                </div>
                <div>
                <img className="sm:w-32 w-40 sm:ml-0 ml-16 sm:mt-0 mt-4 " src={cube} alt="cubesCoffee" />
                </div>
            </div>
          </motion.div>

          <div className="bg-mandarin text-white hover:bg-mandarin2 absolute 3xl:left-[680px] xl:left-[450px] 3xl:bottom-80 xl:bottom-64 bottom-36 w-[250px] flex justify-center rounded-lg " >
            <button onClick={() => navigate("/shop") }  className="text-center p-2 flex items-center gap-2  " >
              <img className="w-9 h-8" src={walletG} alt="" />
              Agregar a Google Wallet
              </button>

          </div>

          <div className="bg-mandarin text-white hover:bg-mandarin2 absolute 3xl:bottom-80 3xl:right-[680px] xl:right-[450px] xl:bottom-64 bottom-20 w-[250px] flex justify-center rounded-lg " >
            <button onClick={() => navigate("/shop") }  className="text-center p-2 flex items-center gap-2  " >
              <img className="w-10 h-8" src={WalletA} alt="" />
              Agregar a Apple Wallet
              </button>

          </div>
        </motion.div>
        
      )}
    </AnimatePresence>
  );
}
